import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const BoxTruck = createSvgIcon(
  <path d="M10.5 2.25h6.992c.767 0 1.456.467 1.741 1.179l1.94 4.847L24 10.296v8.454h-3.02a3.375 3.375 0 0 1-6.71 0H9.73a3.375 3.375 0 0 1-6.71 0H1.18L0 16.39V9.75h10.5v-7.5Zm4.318 14.25a3.372 3.372 0 0 1 2.807-1.5c1.17 0 2.201.595 2.807 1.5h1.318v-5.046l-2.422-1.73-2.09-5.224H12.75v12h2.068Zm-4.318 0V12H2.25v3.86l.32.64h.998A3.372 3.372 0 0 1 6.375 15c1.17 0 2.201.595 2.807 1.5H10.5Z" />,
  'BoxTruck'
);

export { BoxTruck };